import { bindServices } from '@/services/api';
import _ from 'lodash';

const api = bindServices('approvers');

// TODO: missing translations and enum spec for the ids
const typeApprover = [
  {
    id: 1,
    name: 'Por grupos',
    description: 'Aprobadores globales por grupo de usuarios',
    route: 'GlobalUserGroupApproverUser',
  },
  {
    id: 2,
    name: 'Por grupo y puesto',
    description: 'Aprobadores globales por grupo de usuarios y puestos',
    route: 'GlobalUserGroupApproverByPosition',
  },
  {
    id: 3,
    name: 'Por grupo y área',
    description: 'Aprobadores globales por grupo de usuarios y área',
    route: 'GlobalUserGroupApproverByArea',
  },
  {
    id: 4,
    name: 'Por entidad',
    description: 'Aprobadores globales por entidades y usuarios',
    route: 'GlobalEntityApproverUser',
  },
  {
    id: 5,
    name: 'Por entidad y grupo',
    description: 'Aprobadores globales por entidades y grupos de usuarios',
    route: 'GlobalEntityApproverByUserGroup',
  },
  {
    id: 6,
    name: 'Por entidad y puesto',
    description: 'Aprobadores globales por entidades y puestos',
    route: 'GlobalEntityApproverByPosition',
  },
  {
    id: 7,
    name: 'Por entidad y área',
    description: 'Aprobadores globales por entidad y área',
    route: 'GlobalEntityApproverByArea',
  },
];

const Model = {
  namespace: 'approvers',
  state: {
    list: [],
    newApprover: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'approvers/count',
          params: payload,
        });
        yield put({
          type: 'queryApproversGroups',
          payload: response,
        });
      } catch (error) {
        /*  */
      }
    },

    *hideAllForms(state, { put }) {
      yield put({ type: 'hideAll' });
    },
  },

  reducers: {
    queryApproversGroups(state, { payload }) {
      const data = _.map(typeApprover, (item) => {
        return {
          ...item,
          count: _.find(payload, { type: item.id }).count,
        };
      });

      return {
        ...state,
        data,
      };
    },

    hideAll(state) {
      return {
        ...state,
        newApprover: false,
        approverDetails: false,
      };
    },
  },
};

export default Model;
